import { Banner } from "../../model/novedades/Banner";
import styled from "styled-components";
import {
  LayoutProps,
  layout,
  WidthProps,
  width,
  BorderProps,
  border,
} from "styled-system";
import { SlideTitle } from "./SlideTitle";
import {
  CARROUSEL_RADIUS,
  SLIDETITLE_DEFAULT_LABEL,
} from "../../constants/data";
import { Anchor, Box } from "@bpba/ui-components";

type SlideProps = {
  item: Banner;
  index: number;
  fullBorderRadius: boolean | undefined;
};

export function Slide(props: SlideProps) {
  return (
    <Anchor
      data={props.item}
      tabIndex={-1}
      display="flex"
      alignItems="center"
      textAlign="center"
    >
      <SlideTitle
        title={props?.item?.titulos?.titleDesktop}
        description={props?.item?.descripciones?.descripcionDesktop}
        callToAction={props?.item?.textoCallToAction}
        countdownDate={props?.item?.fechaCuentaRegresiva}
        display={["none", null, null, "flex"]}
      />
      <SlideTitle
        title={props?.item?.titulos?.titleTablet}
        description={props?.item?.descripciones?.descripcionTablet}
        callToAction={props?.item?.textoCallToAction}
        countdownDate={props?.item?.fechaCuentaRegresiva}
        display={["none", "flex", null, "none"]}
      />
      <Box
        display={[
          props?.item?.titulos?.titleMobile ||
          props?.item.descripciones?.descripcionMobile ||
          props?.item?.textoCallToAction
            ? "flex"
            : "none",
          "none",
        ]}
        background={`linear-gradient(to top , rgb(235, 235, 235) 0% , rgb(235, 235, 235) 50% , transparent 50% , transparent 100%)`}
        position={"absolute"}
        height={"auto"}
        bottom={"0px"}
        justifyContent={"center"}
      >
        <SlideTitle
          title={props?.item?.titulos?.titleMobile}
          description={props?.item?.descripciones?.descripcionMobile}
          callToAction={props?.item?.textoCallToAction}
          countdownDate={props?.item?.fechaCuentaRegresiva}
        />
      </Box>

      <StyledPicture width="100%">
        <source
          media="(max-width: 413px)"
          sizes="100vw"
          height={498}
          srcSet={props.item?.rutaImagenExtraSmall() + " 360w"}
        />

        <source
          media="(max-width: 575px)"
          sizes="100vw"
          height={498}
          srcSet={props.item?.rutaImagenSmall() + " 414w"}
        />

        <source
          media="(max-width: 992px)"
          sizes="100vw"
          height={550}
          srcSet={props.item?.rutaImagenMedium() + " 768w"}
        />

        <source
          media="(min-width: 992px)"
          sizes="100vw"
          height={360}
          srcSet={props.item?.rutaImagenLarge() + " 1152w"}
        />

        <SlideImg
          src={props.item?.rutaImagenLarge()}
          loading={props.index === 0 ? "eager" : "lazy"}
          display={"flex"}
          alt={
            props?.item.titulos?.titleDesktop
              ? props?.item.titulos.titleDesktop + " texto alternativo"
              : SLIDETITLE_DEFAULT_LABEL
          }
          width="100% !important"
          borderRadius={
            props.fullBorderRadius
              ? [null, null, null, CARROUSEL_RADIUS]
              : [
                  null,
                  null,
                  null,
                  `${CARROUSEL_RADIUS}px ${CARROUSEL_RADIUS}px  0px  0px`,
                ]
          }
        />
      </StyledPicture>
    </Anchor>
  );
}

const StyledPicture = styled.picture<WidthProps>(width);

const SlideImg = styled.img<LayoutProps & BorderProps>(layout, border, {
  objectFit: "cover",
  objectPosition: "center",
  fetchPriority: "high",
});
